import { createFileRoute } from '@tanstack/react-router'

import { AdminsPage } from '#/modules/admins/admins-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/admins')({
  component: AdminsPage,
  validateSearch: validateListSearch,
})
